var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FF6A61",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16 5c6.075 0 11 4.925 11 11s-4.925 11-11 11S5 22.075 5 16 9.925 5 16 5zM7 16c0 4.97 4.03 9 9 9 2.125 0 4.078-.736 5.617-1.968l-12.65-12.65C7.738 11.923 7 13.876 7 16zm9-9c-2.125 0-4.078.736-5.617 1.968l12.65 12.65C24.262 20.077 25 18.124 25 16c0-4.97-4.03-9-9-9z",
    transform: "translate(-1092 -743) translate(0 720) translate(1076 16) translate(16 8)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCancel);
export default __webpack_public_path__ + "static/media/ico-cancel.daae23cf9e4f24c2bbda03414ce88a8d.svg";
export { ForwardRef as ReactComponent };